import styled from 'styled-components'
import { mainTheme } from '../../../styles/mainTheme'

export const VacinasLogo = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  padding: ${mainTheme.spacing(2)}px;
`
